/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
// This rule need to be disabled because some value are falsy, but not only undefined or null
import { FormattedMessage } from 'react-intl';
import { LineItem } from 'shared/types/cart';
import { centsToDollarString } from 'utils/price';

import './styles.scss';

type OrderItemSummaryProps = {
  lineItems: LineItem[];
};

export const OrderItemSummary = ({ lineItems }: OrderItemSummaryProps) => (
  <>
    <h2 className="mb-0">
      <FormattedMessage
        id="payment.order.details.items"
        defaultMessage="Order items"
        description="Order items heading"
      />
    </h2>

    <dl className="attribute-list">
      {lineItems?.map((item) => (
        <div className="item" key={item.productId}>
          <div className="attribute">
            <dt>
              <FormattedMessage
                id="payment.order.details.item.name"
                defaultMessage="Name"
                description="Item name"
              />
            </dt>
            <dd>{item?.name}</dd>
          </div>

          <div className="attribute">
            <dt>
              <FormattedMessage
                id="payment.order.details.item.price"
                defaultMessage="Price"
                description="Item price"
              />
            </dt>
            <dd translate="no">
              {centsToDollarString(item.price?.centAmount || 0, 2)}
            </dd>
          </div>

          <div className="attribute">
            <dt>
              <FormattedMessage
                id="payment.order.details.discount.amount"
                defaultMessage="Discount amount"
                description="Order discount amount"
              />
            </dt>
            <dd translate="no">
              {centsToDollarString(
                item.discounts?.at(0)?.discountedAmount?.centAmount || 0,
                2,
              )}
            </dd>
          </div>

          <div className="attribute">
            <dt>
              <FormattedMessage
                id="payment.order.details.total"
                defaultMessage="Total after discount"
                description="Total amount after the discount"
              />
            </dt>
            <dd translate="no">
              {centsToDollarString(item.totalPrice?.centAmount || 0, 2)}
            </dd>
          </div>
        </div>
      ))}
    </dl>
  </>
);
